import state from './state'
import getters from './getters'
import actions from './actions'
import mutations from './mutations'

export const SOCIAL_NETWORKS_STORE_NAME = 'socialNetworks'

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
